import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/bus/busTreatResult/list',params);
    },
  
    add(params) {
      return common.post('/rocheManage/bus/busTreatResult/add',params);
    },
  
    edit(params) {
      return common.put('/rocheManage/bus/busTreatResult/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/bus/busTreatResult/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/bus/busTreatResult/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/bus/busTreatResult/exportXls', params, {responseType: 'blob'});
    },

    importUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busTreatResult/importExcel', params);
    },
  
    importValidUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busTreatResult/importExcelValid', params);
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/domainresult.js